import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import client from "../lib/api";
import { ArrowLeft, Calendar } from "lucide-react";

const levels = [
    { id: "beginner", label: "Beginner" },
    { id: "intermediate", label: "Intermediate" },
    { id: "advanced", label: "Advanced" },
];

export default function WorkoutPlan() {
    const [level, setLevel] = useState("beginner");
    const [plan, setPlan] = useState(null);

    useEffect(() => {
        client.get("/workout-plan", { params: { level } }).then((r) => setPlan(r.data));
    }, [level]);

    return (
        <div className="px-5 pt-8 pb-8">
            <Link to="/app" className="inline-flex items-center text-zinc-500 hover:text-white">
                <ArrowLeft size={18} />
                <span className="ml-2 label-cap text-xs">Home</span>
            </Link>
            <div className="mt-4 flex items-center gap-3">
                <Calendar className="text-neon-green" size={28} />
                <div>
                    <span className="label-cap text-xs text-neon-green">Weekly Plan</span>
                    <h1 className="font-display font-black text-3xl uppercase tracking-tight">7-Day Grind</h1>
                </div>
            </div>

            <div className="mt-6 flex gap-2">
                {levels.map((l) => (
                    <button
                        key={l.id}
                        onClick={() => setLevel(l.id)}
                        data-testid={`plan-${l.id}`}
                        className={`flex-1 py-2 label-cap text-xs transition-all ${
                            level === l.id ? "bg-neon-orange text-white" : "surface-1 text-zinc-400"
                        }`}
                    >
                        {l.label}
                    </button>
                ))}
            </div>

            {plan && (
                <>
                    <div className="mt-4 surface-2 p-3 flex items-center justify-between">
                        <span className="label-cap text-xs text-zinc-500">Days/Week</span>
                        <span className="font-display font-black text-2xl text-neon-green">{plan.days_per_week}</span>
                    </div>

                    <div className="mt-4 space-y-2">
                        {plan.schedule.map((d, i) => (
                            <div
                                key={i}
                                className={`surface-1 p-3 flex gap-3 ${
                                    d.rest ? "opacity-70 border-l-2 border-l-zinc-600" : "border-l-2 border-l-neon-green"
                                }`}
                            >
                                <div className="w-12 text-center">
                                    <div className="label-cap text-[10px] text-zinc-500">{d.day.slice(0, 3)}</div>
                                    <div
                                        className="font-display font-black text-2xl mt-1"
                                        style={{ color: d.rest ? "#737373" : "#39FF14" }}
                                    >
                                        {i + 1}
                                    </div>
                                </div>
                                <div className="flex-1 min-w-0">
                                    <div className="font-display font-bold uppercase text-sm">{d.focus}</div>
                                    <ul className="mt-1 space-y-0.5 text-xs text-zinc-400">
                                        {d.exercises.map((e, j) => (
                                            <li key={j}>• {e}</li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        ))}
                    </div>
                </>
            )}

            <div className="mt-6 surface-1 p-4 border-l-2 border-l-neon-orange">
                <div className="label-cap text-xs text-neon-orange">Recovery Reminder</div>
                <p className="text-xs text-zinc-400 mt-2">
                    Rest is part of the grind. Sleep 7-8 hours. Hydrate. Stretch daily. Skipping recovery breaks
                    streaks of a different kind.
                </p>
            </div>
        </div>
    );
}
